import { AudioDevice } from './AudioDevice';
import { AudioResource } from './AudioResource';
import { AudioDataSource } from './AudioDataSource';
import { IMediaContainer } from './IMediaContainer';
import { AudioData } from './AudioData';
import { ResourcePool } from './ResourcePool';
import { IAssetsUrlFormatter } from '../helpers/assets-url.formatter';

export class AudioResourcePool extends ResourcePool<AudioResource> {
  public static readonly Buffer: string = 'audio';
  public static readonly Stream: string = 'sound_stream';

  private readonly _audioDevice: AudioDevice;

  constructor(audioDevice: AudioDevice, assetsUrlFormatter?: IAssetsUrlFormatter) {
    super(assetsUrlFormatter);
    this._audioDevice = audioDevice;
  }

  public get requiresMediaContainer(): boolean {
    return true;
  }

  public async loadResourceData(
    resource: AudioResource,
    xml: HTMLElement,
    container: IMediaContainer | null
  ): Promise<void> {
    const sources: AudioDataSource[] = [];
    for (let i = 0; i < xml.children.length; ++i) {
      const source = xml.children[i];
      const url = this.formatUrl(source.getAttribute('path')!);
      sources[i] = new AudioDataSource(url, source.getAttribute('type')!);
    }

    let task: Promise<AudioData | null>;
    if (xml.nodeName === AudioResourcePool.Buffer) {
      task = this._audioDevice.decodeBuffer(sources);
    } else {
      if (!container) {
        task = this._audioDevice.openStream(sources);
      } else {
        task = this._audioDevice.openStreamInContainer(sources, container);
      }
    }

    task.then((data) => {
      if (data) {
        resource.construct(data);
      }
    });
  }

  public createResource(resourceId: string): AudioResource {
    return new AudioResource(resourceId);
  }
}
